import * as tsx from 'vue-tsx-support';
import { UserStore } from '@/store';
import * as utils from '@/utils';
import ExamSessionFooter from './ExamSessionFooter';
import StudentExamFooter from './StudentExamFooter';
import StudentViewFooter from './StudentViewFooter';
import './style.less';
export default tsx.component({
    name: 'session-footer',
    /** @returns The rendered component. */
    render() {
        const exam = UserStore.examSession();
        const studentView = UserStore.studentView();
        if (exam.tag === 'enabled' && studentView.tag === 'enabled') {
            return <StudentExamFooter />;
        }
        else if (exam.tag === 'enabled') {
            return <ExamSessionFooter />;
        }
        else if (studentView.tag === 'enabled') {
            return <StudentViewFooter />;
        }
        return utils.emptyVNode();
    },
});
